function stripDiacritics(string) {
  return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
export function createFilterOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$ignoreAccents = _ref.ignoreAccents,
    ignoreAccents = _ref$ignoreAccents === void 0 ? true : _ref$ignoreAccents,
    _ref$ignoreCase = _ref.ignoreCase,
    ignoreCase = _ref$ignoreCase === void 0 ? true : _ref$ignoreCase,
    limit = _ref.limit,
    _ref$matchFrom = _ref.matchFrom,
    matchFrom = _ref$matchFrom === void 0 ? "any" : _ref$matchFrom,
    stringify = _ref.stringify,
    _ref$trim = _ref.trim,
    trim = _ref$trim === void 0 ? false : _ref$trim;
  return function (options, _ref2) {
    var inputValue = _ref2.inputValue,
      getOptionLabel = _ref2.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;
    if (ignoreCase) {
      input = input.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
    }
    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);
      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }
      return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
  };
}